module.exports = __webpack_public_path__ + "img/havannaoak694m_detail_rsh2.ac533895.jpg";